import * as Yup from 'yup'

export const initialEditFormValues = (values) => {
    return {
        attribute_id: values.attribute_id || "",
        attribute_name: values.attribute_name || "",
        status: "" + (values.status ?? "")
    }
}

export const editFormValidationSchema = Yup.object({
    attribute_name: Yup.string().required('This field is required'),
    status: Yup.string().required('This field is required'),
})